<div data-test-automation="former-tenure-summary">
    <table class="table table-hover table-striped">
        <thead>
            <tr class="default">
                <th class="text-nowrap">{{dataLabelMap.parentPlanType}}</th>
                <th class="text-nowrap">{{dataLabelMap.parentPlan}}</th>
                <th class="text-nowrap">{{dataLabelMap.parentLot}}</th>
                <th class="text-nowrap">{{dataLabelMap.titleReference}}</th>
                <th class="text-nowrap">{{dataLabelMap.subjectLandDescription}}</th>
                @if (isDigitalOrPortalPlan()) {
                    <th class="text-nowrap">{{dataLabelMap.newLotsLand}}</th>
                }
                <th class="text-nowrap">{{dataLabelMap.localGovernment}}</th>
                <th class="text-nowrap">{{dataLabelMap.locality}}</th>
                <th>&nbsp;</th>
            </tr>
        </thead>
        @for (tenureSummary of summaryViewModel.tenures; track tenureSummary; let tenureIndex = $index) {
            <tbody>
                @if (tenureSummary.lots.length === 0) {
                    <tr>
                        <td>
                            <span>{{tenureSummary.parentPlanType}}</span>
                        </td>
                        <td>
                            <span>{{tenureSummary.parentPlan}}</span>
                        </td>
                        <!-- Parent lot -->
                        <td>&nbsp;</td>
                        <td>
                            <span>{{tenureSummary.title}}</span>
                        </td>
                        <td>
                            <span>{{tenureSummary.subjectLandDescription}}</span>
                        </td>
                        @if (isDigitalOrPortalPlan()) {
                            <td>
                                <span>{{tenureSummary.newLotDetails}}</span>
                            </td>
                        }
                        <!-- Local government area -->
                        <td>&nbsp;</td>
                        <!-- Locality -->
                        <td>&nbsp;</td>
                        <td>
                            @if (!removeTenureDisabled) {
                                <i
                                    class="nlrp-icon nlrp-icon-trash"
                                    tabindex="0"
                                    (click)="removeTenure(tenureIndex)"
                                    data-test-automation="former-tenure-summary-remove-tenure"></i>
                            }
                        </td>
                    </tr>
                }
                @for (lot of tenureSummary.lots; track lot; let lotIndex = $index) {
                    <tr>
                        <td>
                            @if (lotIndex===0) {
                                <span>{{tenureSummary.parentPlanType}}</span>
                            }
                        </td>
                        <td>
                            @if (lotIndex===0) {
                                <span>{{tenureSummary.parentPlan}}</span>
                            }
                        </td>
                        <td>
                            <span>{{lot.parentLotIdentifier}}</span>
                        </td>
                        <td>
                            <span>{{lot.titles}}</span>
                        </td>
                        <!-- Subject land description -->
                        <td>&nbsp;</td>
                        @if (isDigitalOrPortalPlan()) {
                            <td>
                                <span>{{lot.newLotDetails}}</span>
                            </td>
                        }
                        <td>
                            <span>{{lot.lga}}</span>
                        </td>
                        <td>
                            <span>{{lot.locality}}</span>
                        </td>
                        <td>
                            @if (!removeLotDisabled) {
                                <i
                                    class="nlrp-icon nlrp-icon-trash"
                                    tabindex="0"
                                    (click)="removeLot(tenureIndex, lotIndex)"
                                    data-test-automation="former-tenure-summary-remove-lot"></i>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        }
        <tbody> </tbody
    ></table>
</div>
